"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Icon } from "@repo/ui/icon";
import { ActionLink } from "@/components/common/actions/actions.component";
import { MenuItemLink } from "@/components/navigation/menu-item-link.component";
import type { SearchSettings } from "@/components/navigation/navigation.types";
import type { useSearchHistory } from "./use-search-history";
type SuggestionItem = NonNullable<NonNullable<SearchSettings>["searchRecommendedItems"]>[number];
type PopularSearch = NonNullable<NonNullable<SearchSettings>["popularSearches"]>[number];
interface SearchSuggestionsProps {
  suggestions: SuggestionItem[] | null;
  popularSearches: PopularSearch[] | null;
  searchHistory: ReturnType<typeof useSearchHistory>;
  onSearchTerm: (term: string) => void;
}
export function SearchSuggestions(t0) {
  const $ = _c(44);
  const {
    suggestions,
    popularSearches,
    searchHistory,
    onSearchTerm
  } = t0;
  const t = useTranslations("search");
  const {
    history,
    removeSearch
  } = searchHistory;
  let t1;
  if ($[0] !== t) {
    t1 = t("suggestions");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("suggestions");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h3 className="typography-component-xs-medium text-text-link uppercase tracking-wider mb-6">{t2}</h3>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== suggestions) {
    t4 = suggestions && suggestions.length > 0 ? <ul className="space-y-4">{suggestions.map(_temp)}</ul> : null;
    $[6] = suggestions;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = <section className="py-6 tablet:py-0 tablet:pr-8" aria-label={t1}>{t3}{t4}</section>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("popularSearches");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("popularSearches");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <h3 className="typography-component-xs-medium text-text-link uppercase tracking-wider mb-6">{t7}</h3>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== onSearchTerm || $[19] !== popularSearches) {
    t9 = popularSearches && popularSearches.length > 0 ? <ul className="space-y-4">{popularSearches.map(item_0 => {
        if (!item_0.term) {
          return null;
        }
        return <li key={item_0._key}>{item_0.to ? <ActionLink actionTo={item_0.to as Parameters<typeof ActionLink>[0]["actionTo"]} className="cursor-pointer typography-component-sm-medium text-text-primary hover:text-text-link-hover transition-colors">{item_0.term}</ActionLink> : <button type="button" onClick={() => onSearchTerm(item_0.term)} className="cursor-pointer typography-component-sm-medium text-text-primary hover:text-text-link-hover transition-colors">{item_0.term}</button>}</li>;
      })}</ul> : null;
    $[18] = onSearchTerm;
    $[19] = popularSearches;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t6 || $[22] !== t8 || $[23] !== t9) {
    t10 = <section className="py-6 tablet:py-0 tablet:px-8" aria-label={t6}>{t8}{t9}</section>;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("previousSearches");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t) {
    t12 = t("previousSearches");
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12) {
    t13 = <h3 className="typography-component-xs-medium text-text-link uppercase tracking-wider mb-6">{t12}</h3>;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== history || $[32] !== onSearchTerm || $[33] !== removeSearch || $[34] !== t) {
    t14 = history.length > 0 ? <ul className="space-y-4">{history.map(term => <li key={term} className="flex items-center gap-2"><button type="button" onClick={() => onSearchTerm(term)} className="flex cursor-pointer items-center gap-2 typography-component-sm-medium text-text-primary hover:text-text-link-hover transition-colors"><Icon name="history" size="md" className="flex-shrink-0 text-text-secondary" /><span>{term}</span></button><button type="button" onClick={() => removeSearch(term)} className="ml-auto flex-shrink-0 cursor-pointer text-text-disabled hover:text-text-primary transition-colors" aria-label={t("removeFromHistory", {
          term
        })}><Icon name="close" size="sm" /></button></li>)}</ul> : <p className="typography-component-sm-regular text-text-secondary">{t("noPreviousSearches")}</p>;
    $[31] = history;
    $[32] = onSearchTerm;
    $[33] = removeSearch;
    $[34] = t;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t11 || $[37] !== t13 || $[38] !== t14) {
    t15 = <section className="py-6 tablet:py-0 tablet:pl-8" aria-label={t11}>{t13}{t14}</section>;
    $[36] = t11;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t10 || $[41] !== t15 || $[42] !== t5) {
    t16 = <div className="flex flex-col-reverse divide-y divide-border-subtle tablet:grid tablet:grid-cols-3 tablet:gap-0 tablet:divide-y-0 tablet:divide-x">{t5}{t10}{t15}</div>;
    $[40] = t10;
    $[41] = t15;
    $[42] = t5;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  return t16;
}
function _temp(item) {
  return <li key={item._key}><MenuItemLink item={item as Parameters<typeof MenuItemLink>[0]["item"]} colour={item.colour} /></li>;
}